import { useAtom } from 'jotai/index'

import { chatSettingsAtom } from '@/store/gigiChat/ChatAtom.ts'

import MobileChatSettingsDrawer from './components/chat/components/mobileChatSettingsDrawer'
import MobileHistoryDrawer from './components/chat/components/mobileHistoryDrawer'
import PromptLibraryDrawer from './components/chat/components/promptLibraryDrawer'
import ChatContainer from './components/ChatContainer'

const ChatPage = () => {
    const [chatSettings] = useAtom(chatSettingsAtom)

    return (
        <>
            <ChatContainer />
            <MobileChatSettingsDrawer />
            <MobileHistoryDrawer />
            {/*we require chat settings to exist when prompt library is loaded/rendered*/}
            {chatSettings !== null && <PromptLibraryDrawer />}
        </>
    )
}

export default ChatPage
